import { SetStateAction, Dispatch, createContext } from 'react';

function voidSet() {}

export const actorApiLoadingContext = createContext<[boolean, Dispatch<SetStateAction<boolean>>]>([true, voidSet]);
